import type { UserRetailAccount } from '../types';

/** NQ gold — first slot when any live account is compared. */
export const LIVE_COMPARISON_COLOR = '#F7941D';

/** Slot-ordered palette: no gold repeat until palette wraps. */
export const COMPARISON_SLOT_PALETTE = [
  LIVE_COMPARISON_COLOR,
  '#2EE66B',
  '#25B4E0',
  '#a78bfa',
  '#f472b6',
  '#38bdf8',
  '#FF8042',
  '#e879f9',
  '#94a3b8',
] as const;

/** Palette when comparing paper-only accounts (skip gold on slot 0). */
export const COMPARISON_SLOT_PALETTE_PAPER_ONLY = [
  '#25B4E0',
  '#2EE66B',
  '#a78bfa',
  '#f472b6',
  '#38bdf8',
  '#FF8042',
  '#e879f9',
  '#94a3b8',
] as const;

/** @deprecated Use COMPARISON_SLOT_PALETTE — kept for exports. */
export const PAPER_COMPARISON_PALETTE = [
  '#25B4E0',
  '#2EE66B',
  '#a78bfa',
  '#f472b6',
  '#38bdf8',
  '#FFBB28',
  '#94a3b8',
] as const;

export const LIVE_COMPARISON_EXTRA_PALETTE = ['#FF8042', '#e879f9'] as const;

export const assignComparisonColorForAccount = (
  account: Pick<UserRetailAccount, 'isPaper'>,
  paperIndex: number,
  liveIndex: number,
): string => {
  if (!account.isPaper) {
    if (liveIndex === 0) return LIVE_COMPARISON_COLOR;
    return LIVE_COMPARISON_EXTRA_PALETTE[
      (liveIndex - 1) % LIVE_COMPARISON_EXTRA_PALETTE.length
    ];
  }
  return PAPER_COMPARISON_PALETTE[paperIndex % PAPER_COMPARISON_PALETTE.length];
};

/** Assign stable comparison colors keyed by account id (slot order). */
export const assignComparisonColors = (
  accounts: Pick<UserRetailAccount, 'id' | 'isPaper'>[],
): Record<string, string> => {
  const hasLive = accounts.some((a) => !a.isPaper);
  const palette = hasLive
    ? COMPARISON_SLOT_PALETTE
    : COMPARISON_SLOT_PALETTE_PAPER_ONLY;

  const colors: Record<string, string> = {};
  accounts.forEach((account, index) => {
    colors[account.id] = palette[index % palette.length]!;
  });
  return colors;
};

/** @deprecated Use assignComparisonColors */
export const COMPARISON_PALETTE = [
  ...PAPER_COMPARISON_PALETTE,
  LIVE_COMPARISON_COLOR,
] as const;

/** @deprecated Use assignComparisonColorForAccount */
export const assignComparisonColor = (index: number): string =>
  COMPARISON_PALETTE[index % COMPARISON_PALETTE.length];
